import { type DateInput, isSameMonth } from '@repo/common';
import { usePeriodCalendar } from '@repo/ui/fixtures/smallCalendar/hooks/use-calendar';
import { getMonthKey, getMonthLabel } from '@repo/ui/utils/time/month-time';

import { YearlyCalendarMonthDay } from '../YearlyCalendarMonthDay/YearlyCalendarMonthDay';

import './YearlyMonthGrid.scss';

interface YearlyMonthGridProps {
  onMonthClick: (month: DateInput) => void;
}

export function YearlyMonthGrid({ onMonthClick }: YearlyMonthGridProps) {
  const { currentPeriodDays, selectedDay } = usePeriodCalendar();
  const today = new Date();

  return (
    <div className="YearlyMonthGrid">
      {currentPeriodDays.map(monthDays => {
        const firstDayOfMonth = monthDays[0];
        const isSelectedMonth = isSameMonth(firstDayOfMonth, selectedDay);
        const isCurrentMonth = isSameMonth(firstDayOfMonth, today);

        return (
          <YearlyCalendarMonthDay
            key={getMonthKey(firstDayOfMonth)}
            month={firstDayOfMonth}
            monthLabel={getMonthLabel(firstDayOfMonth)}
            onClick={() => onMonthClick(firstDayOfMonth)}
            isSelected={isSelectedMonth}
            isCurrentMonth={isCurrentMonth}
          />
        );
      })}
    </div>
  );
}
